import React, { useState } from "react";
import { Container, TextField, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Импортируем useNavigate
import api from "../../api/api"; // Убедитесь, что этот путь правильный
import { useSnackbar } from "notistack"; // Для уведомлений

function LoginAdmin() {
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate(); // Инициализируем useNavigate
  const { enqueueSnackbar } = useSnackbar(); // Инициализируем уведомления

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post("/admin/login", loginData); // Запрос на сервер
      enqueueSnackbar("Успешный вход!", { variant: "success" });

      // Сохраняем токен (если возвращается токен)
      const token = response.data.access_token;
      if (token) {
        localStorage.setItem("token", token);
      }

      // Переход в админку
      navigate("/admin-panel");
    } catch {
      enqueueSnackbar("Ошибка входа. Проверьте email и пароль.", {
        variant: "error",
      });
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        Вход администратора
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          name="email"
          type="email"
          value={loginData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Пароль"
          name="password"
          type="password"
          value={loginData.password}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <Button variant="contained" color="primary" type="submit" fullWidth>
          Войти
        </Button>
      </form>
    </Container>
  );
}

export default LoginAdmin;
